import { Pipe, PipeTransform } from '@angular/core';

import { CountriesVm } from '@booking/entities/countries';

@Pipe({
  name: 'countriesVm',
  standalone: false
})
export class CountriesVmPipe implements PipeTransform {

  transform(countries: string[]): CountriesVm[] {
    return countries.map(country => {
      const parts = country.split('(');
      const code = parts[1].replace(')', '');
      const name = parts[0].replace(/\s*$/, '');
      return { name: name, code: code };
    }).sort();
  }
}
